export default "__VITE_ASSET__Ll17_Kcx__"